(function () {
  const KEY_PREFIX = "vs_scroll_state::";

  function keyFor(url) {
    return KEY_PREFIX + url;
  }

  function isSameUrl(a, b) {
    // نخليها strict قد ما نقدر (بنفس href)
    return a === b;
  }

  function getFeaturedSliders() {
    // سلايدر الهوم (featured collection)
    return Array.from(document.querySelectorAll('.featured-collection slider-component [id^="Slider-"]'));
  }

  function saveState() {
    try {
      const url = window.location.href;
      const y = window.scrollY || document.documentElement.scrollTop || 0;

      const sliders = getFeaturedSliders().map((el) => ({
        id: el.id,
        left: el.scrollLeft || 0,
      }));

      const payload = {
        url,
        y,
        sliders,
        t: Date.now(),
      };

      sessionStorage.setItem(keyFor(url), JSON.stringify(payload));
      sessionStorage.setItem(KEY_PREFIX + "last_url", url);
    } catch (e) {}
  }

  function restoreState() {
    try {
      const url = window.location.href;
      const raw = sessionStorage.getItem(keyFor(url));
      if (!raw) return;

      const data = JSON.parse(raw);
      if (!data || !isSameUrl(data.url, url)) return;

      const y = parseInt(data.y || 0, 10);

      // 1) ريستور عمودي فورًا
      window.scrollTo(0, y);

      // 2) ريستور أفقي للسلايدر بعد ما الـDOM يستقر
      const apply = () => {
        window.scrollTo(0, y);

        const slidersNow = getFeaturedSliders();
        slidersNow.forEach((sliderEl) => {
          const found = (data.sliders || []).find((s) => s.id === sliderEl.id);
          if (found) sliderEl.scrollLeft = found.left;
        });
      };

      requestAnimationFrame(() => {
        apply();
        requestAnimationFrame(() => {
          apply();
          setTimeout(apply, 60);
          setTimeout(apply, 200);
        });
      });
    } catch (e) {}
  }

  // ✅ احفظ الحالة في أي وقت قبل الخروج/الانتقال
  window.addEventListener("pagehide", saveState);
  window.addEventListener("beforeunload", saveState);

  // ✅ ريستور على الرجوع (BFCache) وكمان على الريفريش لو الثيم بيصفر الاسكرول
  window.addEventListener("pageshow", function () {
    restoreState();
  });

  // ✅ احفظ قبل الدخول لأي منتج (عشان الرجوع يرجع نفس المكان)
  document.addEventListener(
    "click",
    function (e) {
      const a = e.target.closest('a[href]');
      if (!a) return;

      // نخزن فقط لو داخل على صفحة product
      if (a.getAttribute("href") && a.getAttribute("href").includes("/products/")) {
        saveState();
      }
    },
    { capture: true }
  );

})();